// 一位小数正则
export const matchFractionalPart1 = /^\d+(\.[0-9]{1})?$/g
// 两位小数正则
export const matchFractionalPart2 = /^\d+(\.[0-9]{1,2})?$/g
// 正整数 + 0
export const matchInteger = /^\+?[0-9]*$/
// 银行卡正则
export const matchBankCard = /^(?:62|88|99|19\d{2}|4\d{3}|5[1-5]\d{2}|6\d{3}|81\d{2})\d{10}|^62\d{12,17}|^[0-9]{16,19}$/
// 手机号
export const matchMobile = /^1\d{10}$/
// 正整数
export const matchIntegerNew = /^\+?[1-9]\d*$/


// WEBPACK FOOTER //
// ./src/utils/regExp.js